import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { api } from '../../services/api';           // 🛣 adjust path if different

/**
 * CreateLink
 * Generates a private share link for a research project.
 *
 * Props
 * ────────────────────────────────────────────────
 * • userData   → { userID, researchID }
 * • onSuccess  → function(linkUrl)   (called once the link is ready)
 * • disabled   → boolean             (external disable flag)
 */
function CreateLink({ userData, onSuccess = () => {}, disabled = false }) {
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (loading || !userData?.userID || !userData?.researchID) return;

    try {
      setLoading(true);

      // expiresInDays is fixed at 90 per requirements
      const res = await api.createSharedLink(
        userData.userID,
        userData.researchID,
        90
      );

      if (res?.url) {
        onSuccess(res.url);   // hand the link back to parent dialog
      }
    } catch (err) {
      // TODO: surface an error to the user
      console.error('createSharedLink failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleCreate}
      disabled={disabled || loading}
      startIcon={
        loading ? <CircularProgress size={18} color="inherit" /> : null
      }
      sx={{ minWidth: 120 }}
    >
      {loading ? 'Creating…' : 'Create link'}
    </Button>
  );
}

export default CreateLink;
